import React, { Component } from 'react'
import BoardItem from '../component/BoardItem'
import { getMerchantCount, getMerchantOrderList, postWithdrawal, getMerchantInfo } from '../../../api/api'
import { Table, message, Form, Input, Modal, Button } from 'antd'
import './style.less'
class merchants extends Component {
  state = {
    loading: false,
    visible: false,
    fileList: [],

    isLoading: true,

    params: {
      pageNum: 0,
      pageSize: 10,
    },

    pageData: {
      total: 0,
      current: 1,
    },
    list: [],
    notValid: 0,
    valid: 0,
    balance: 0,
    frozenBalance: 0,
    integral: 0,
  }

  componentDidMount () {
    const { params } = this.state
    getMerchantCount().then(res => {
      this.setState({
        notValid: res.data.orderInfo.notValid,
        valid: res.data.orderInfo.valid,
        balance: res.data.walletInfo.balance,
        frozenBalance: res.data.walletInfo.frozenBalance,
        integral: res.data.walletInfo.integral,
      })
    })

    this.loadList(params)
  }

  // 获取银行卡信息
  getMerchantInfo () {

  }
  loadList (params) {
    const hide = message.loading('加载中...', 0)
    this.setState({ isLoading: true })
    getMerchantOrderList(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
        hide()
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }
  // 分页
  onPageChange = (e) => {
    if (this.state.isLoading) {
      return false
    }
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }
  showModal = () => {
    this.setState({
      visible: true,
    })
  }

  handleOk = () => {
    const { getFieldsValue } = this.props.form
    let param = getFieldsValue()
    if (!param.amount) {
      return false
    }
    param.amount *= 100
    this.setState({ loading: true })
    postWithdrawal(param).then(res => {
      getMerchantCount().then(res => {
        this.setState({
          notValid: res.data.orderInfo.notValid,
          valid: res.data.orderInfo.valid,
          balance: res.data.walletInfo.balance,
          frozenBalance: res.data.walletInfo.frozenBalance,
          integral: res.data.walletInfo.integral,
          loading: false,
          visible: false
        })
      })
    })
      .catch(e => {
        this.setState({ loading: false, visible: false })
      })
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }

  render () {
    const columns = [
      {
        title: '订单号',
        dataIndex: 'orderSn',
        key: 'orderSn',
      },
      {
        title: '交易金额',
        render: (c) => {
          return (c.orderPrice / 100).toFixed(2)
        },
        key: 'orderPrice',
      },
      {
        title: '交易时间',
        dataIndex: 'createAt',
        key: 'createAt',
      },

      {
        /**
  * status：顶部状态内容
  * 11：待支付
  * 12：下单未支付用户取消
  * 13：下单未支付自动取消
  * 21：支付完成，未发货
  * 31：商户发货，用户未确认
  * 41：用户确认收货，订单结束
  * 42：用户没有确认收货，超过一段时间自动确认收货。
  * 51：用户操作退款
  * 61：正常完成
  * 62：通过退款后订单完成
  * 63：商户拒绝退款
  */
        title: '订单状态',
        key: 'status',

        render: (c) => {
          switch (c.status) {
            case 11:
              return '待支付'
            case 12:
              return '已取消'
            case 13:
              return '支付超时'
            case 21:
              return '待发货'
            case 31:
              return '已发货'
            case 41:
              return '已收货'
            case 42:
              return '自动收货'
            case 51:
              return '用户申请退款'
            case 61:
              return '已完成'
            case 62:
              return '已完成(有退款)'
            case 63:
              return '商户拒绝退款'
            default:
              return '订单错误'

          }
        },
      },
    ]
    const { loading, list, pageData, visible, integral, balance, frozenBalance, valid, notValid } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div className='merchants-page'>
        <div className='board'>
          <BoardItem
            icon='pay-circle'
            itemKey='余额'
            itemValue={(balance / 100).toFixed(2)}
            clickCallBack={this.showModal}
            buttonLabel='提现'
          />
          <BoardItem
            icon='pay-circle'
            itemKey='积分剩余'
            itemValue={integral}
            clickCallBack={() => {
              this.props.history.push('/finance/recharge')
            }}
            buttonLabel='充值'
          />
          <BoardItem
            icon='money-collect'
            itemKey='冻结余额'
            itemValue={(frozenBalance / 100).toFixed(2)}
          />
          <BoardItem
            icon='line-chart'
            itemKey='有效订单'
            itemValue={valid}
          />
          <BoardItem
            icon='disconnect'
            itemKey='冻结订单'
            itemValue={notValid}
          />
        </div>
        <div className='tablecontain'>
          <Table
            bordered
            columns={columns}
            dataSource={list}
            rowKey="id"
            pagination={{
              current: pageData.current,
              total: pageData.total,
              pageSize: pageData.pageSize,
            }}
            onChange={this.onPageChange}
          />
        </div>
        <Modal
          visible={visible}
          title="提现"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
              取消
              </Button>,
            <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>
              确定
              </Button>,
          ]}
        >
          <Form className="modal-form">

            <Form.Item label="提现金额" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('amount', {
                rules: [{ required: true, message: '请输入提现金额' }],
              })(
                <Input
                  placeholder="请输入提现金额"
                />,
              )}
            </Form.Item>
            <Form.Item label="银行卡" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('bankCard', {
                rules: [{ required: true, message: '请输入银行卡' }],
              })(
                <Input
                  placeholder="请输入银行卡"
                />,
              )}
            </Form.Item>

          </Form>
        </Modal>

      </div>
    )
  }
}

export default Form.create({ name: 'post_data' })(merchants)